import { CSSProperties, ReactElement, ReactNode, SyntheticEvent } from 'react';
import {
  Chip as MUIChip,
  ChipProps as MUIChipProps,
  SxProps,
  Theme,
} from '@mui/material';
import * as R from 'ramda';

type AtomMUIProps = {
  avatar?: ReactElement<any>;
  classes?: any;
  label?: ReactNode;
  style?: CSSProperties;
  onDelete?: () => void;
  color?:
    | 'default'
    | 'primary'
    | 'secondary'
    | 'error'
    | 'info'
    | 'success'
    | 'warning';
  onClick?: (event: SyntheticEvent<any>) => void;
};

export type ChipProps = AtomMUIProps;

const styles = {
  maxWidth: '100%',
  textOverflow: 'ellipsis',
  overflow: 'hidden',
};

export const Chip = (props: ChipProps) => {
  const labelSx: SxProps<Theme> = {
    '.MuiChip-label': {
      paddingLeft: !!props.avatar ? 0 : '0.5rem',
    },
  };

  const MUIProps: MUIChipProps = R.omit(['style'], props);

  return (
    <MUIChip sx={labelSx} style={{ ...styles, ...props.style }} {...MUIProps} />
  );
};
